import { CSSProperties } from 'react';
import { theme } from '../../theme';

export const checkoutTotalFooterStyles = {
  visuallyHidden: {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
  } as CSSProperties,

  container: {
    position: 'sticky',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.small,
    padding: `${theme.spacing.small}px ${theme.spacing.medium}px`,
    backgroundColor: theme.colors.white,
    fontFamily: theme.typography.fontFamily,
    zIndex: 10,
    // Shadow/Fixed del diseño. Sin `filter: drop-shadow`: en el WebView de Android el pintado de la
    // pantalla salía deformado (sospechado, sin confirmar).
    boxShadow: '2px 2px 4px rgba(18, 18, 18, 0.16)',
  } as CSSProperties,

  flow: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.small,
    padding: `${theme.spacing.small}px ${theme.spacing.medium}px`,
    backgroundColor: theme.colors.white,
    fontFamily: theme.typography.fontFamily,
    boxShadow: '2px 2px 4px rgba(18, 18, 18, 0.16)',
  } as CSSProperties,

  tab: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    height: 21,
    padding: 0,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
  } as CSSProperties,

  tabFolded: { top: -20, width: 150 } as CSSProperties,

  tabUnfolded: { top: -21, width: 172 } as CSSProperties,

  tabBackground: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
  } as CSSProperties,

  tabLabel: {
    position: 'relative',
    display: 'block',
    marginTop: 3,
    fontSize: theme.typography.fontSize.xs,
    lineHeight: '16px',
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.button.primary,
    whiteSpace: 'pre',
  } as CSSProperties,

  summary: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.medium,
    paddingTop: theme.spacing.small,
  } as CSSProperties,

  summaryHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  } as CSSProperties,

  summaryTitle: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.black,
  } as CSSProperties,

  closeButton: {
    position: 'absolute',
    top: -4,
    right: 0,
    display: 'flex',
    padding: 0,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
  } as CSSProperties,

  summaryRows: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.small,
  } as CSSProperties,

  summaryRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  } as CSSProperties,

  summaryText: {
    fontSize: theme.typography.fontSize.sm,
    lineHeight: '20px',
    color: theme.colors.label,
  } as CSSProperties,

  summaryCents: {
    fontSize: 10,
    lineHeight: '16px',
    fontWeight: 300,
    color: theme.colors.label,
  } as CSSProperties,

  discountLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.small,
    fontSize: theme.typography.fontSize.sm,
    lineHeight: '20px',
    color: theme.colors.danger,
  } as CSSProperties,

  discountAmount: {
    fontSize: theme.typography.fontSize.sm,
    lineHeight: '20px',
    color: theme.colors.palette.red200,
  } as CSSProperties,

  discountCents: {
    fontSize: 10,
    lineHeight: '16px',
    fontWeight: 300,
    color: theme.colors.palette.red200,
  } as CSSProperties,

  divider: {
    height: 1,
    backgroundColor: theme.colors.palette.grey200,
  } as CSSProperties,

  totalRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  } as CSSProperties,

  totalLabel: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.black,
  } as CSSProperties,

  amount: {
    display: 'flex',
    alignItems: 'flex-start',
  } as CSSProperties,

  totalWhole: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.black,
  } as CSSProperties,

  totalCents: {
    fontSize: theme.typography.fontSize.xs,
    lineHeight: '16px',
    color: theme.colors.black,
  } as CSSProperties,

  submitButton: {
    width: '100%',
    padding: '12px 16px',
    border: 'none',
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colors.button.primary,
    color: theme.colors.white,
    fontFamily: theme.typography.fontFamily,
    fontSize: 16,
    fontWeight: theme.typography.fontWeight.bold,
    cursor: 'pointer',
    transition: `background-color ${theme.transitions.fast}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  } as CSSProperties,

  submitButtonDisabled: {
    backgroundColor: theme.colors.palette.grey400,
    cursor: 'not-allowed',
  } as CSSProperties,
};
